/**
 * This static class englobes youbora constants.
 * @class
 * @static
 * @memberof youbora
 */
var Constants = {
  /**
 * List of youbora services.
 * @enum
 */
  Service: {
    DATA: '/data',
    INIT: '/init',
    START: '/start',
    JOIN: '/joinTime',
    PAUSE: '/pause',
    RESUME: '/resume',
    SEEK: '/seek',
    BUFFER: '/bufferUnderrun',
    ERROR: '/error',
    STOP: '/stop',
    PING: '/ping',
    AD_START: '/adStart',
    AD_JOIN: '/adJoin',
    AD_PAUSE: '/adPause',
    AD_RESUME: '/adResume',
    AD_BUFFER: '/adBufferUnerrun',
    AD_STOP: '/adStop'
  }
}

module.exports = Constants



//////////////////
// WEBPACK FOOTER
// ./src/constants.js
// module id = 5
// module chunks = 0